/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import gql from "graphql-tag";

export const OrganizationQuery = gql`
  query OrganizationQuery {
    organization: getOrganization {
      id
      name
      plan
      imageUrl
      created
      updated
      trialExpires
      address {
        line1
        line2
        city
        state
        zip
        country
        telephone1
        telephone2
      }
    }
  }
`;

export const UpdateOrganizationMutation = gql`
  mutation UpdateOrganization($organization: OrganizationInput!) {
    updateOrganization(organization: $organization) {
      id
      name
      plan
      imageUrl
      updated
      address {
        line1
        city
        zip
        country
        telephone1
        telephone2
      }
    }
  }
`;

export const SuspendPlanMutation = gql`
  mutation SuspendPlan($options: SuspendPlanInput!) {
    suspendPlan(options: $options) {
      preview
      expires
    }
  }
`;

export const ReactivatePlanMutation = gql`
  mutation ($orgId: ID!) {
    status: reactivatePlan(orgId: $orgId)
  }
`;

export interface OrganizationData {
  organization: Organization;
}

export interface Organization {
  id: string;
  name: string;
  plan: string;
  address: Address;
  imageUrl: string;
  created: number;
  updated: number;
  trialExpires?: number;
}

export interface Address {
  line1: string;
  line2?: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  telephone1: string;
  telephone2: string;
}

export interface OrganizationInput {
  id?: string;
  name: string;
  plan?: string;
  address?: Address;
  imageUrl?: string;
}

export interface SuspendPlanInput {
  orgId: string;
  preview: boolean;
  immediateExpiry: boolean;
  expires: number;
}

export interface AnalyticsInfo {
  enabled: boolean;
}
